import type { ActionType } from '@reducers/action'
import type { AppContextType } from '@reducers/index'
import React from 'react'

const AppContext = React.createContext<
  readonly [AppContextType, React.Dispatch<ActionType>]
>({} as A)
export const useContext = () => {
  return React.useContext(AppContext)
}
export default AppContext
